<template>
    <div class="input-content">
        <div class="upload-wrapper">
            <div class="upload-null-icon">
                <i :class="fileUrl ? 'el-icon-circle-check' : 'el-icon-plus'"></i>
            </div>
            <el-upload
                class="avatar-uploader"
                action=""
                accept="image/*"
                v-if="!oneUpload"
                :show-file-list="false"
                :disabled="typing"
                :multiple="false"
                :auto-upload="false"
                :on-change="getFileUrl">
                <div class="upload-right">
                    <label>点击上传文件</label>
                    <span>（支持格式： .jpg .png）</span>
                </div>
            </el-upload>
            <div class="upload-right file-name" v-else>
                <label>{{ oneUpload.name }}</label>
            </div>
            <div class="uploaded" v-if="oneUpload">
                <el-upload class="avatar-uploader" action="" :show-file-list="false" :auto-upload="false" :on-change="getFileUrl">
                    <span class="ctrl">重新上传</span>
                </el-upload>
                <span @click="delFile" class="ctrl">删除</span>
            </div>
        </div>
        <div class="input-wrapper">
            <div class="user-input-textarea-wrapper" ref="user-input-textarea-wrapper">
                <a-mentions
                    rows="3"
                    autoFocus
                    v-model="prompt"
                    :prefix="['/']"
                    :disabled="typing"
                    class="user-input-textarea" :placeholder="placeholder"
                    @keydown.native.alt.enter.prevent="wrap"
                    @select="selectValue"
                    @blur="handleFocus(false)"
                    @focus="handleFocus(true)"
                    @keydown.native.enter.prevent.exact="ask"
                :getPopupContainer="() => $refs['user-input-textarea-wrapper']">
                    <a-mentions-option :value="item.title" :key="item.value" v-for="item in mentionsList">
                        {{ item.title }}
                    </a-mentions-option>
                </a-mentions>
            </div>
            <div class="textarea-right">
                <mic :prompt.sync="prompt"></mic>
                <img class="send" :class="{'disabled': !prompt}" src="@/theme/images/icons/icon_send.svg" @click="send()" title="发送" />
            </div>
        </div>
    </div>
</template>

<script>
import yjyAPI from '@/api/yjy.api.js';
import UploadMixin from '@/app/mixins/UploadMixin.js';
import mic from './mic.vue';
import MODEL_LIST from '@/app/constant/MODEL_LIST.js';
export default {
    name: 'gpt-chatbox-yjy-person-counting',
    components: { mic },
    mixins: [UploadMixin],
    data () {
        return {
            prompt: '',
            MODEL_LIST
        };
    },
    props: {
        /**
         * 是否正在输入
         */
        typing: {
            type: Boolean,
            default: false
        },
        /**
         * 输入框的占位文字
         */
        placeholder: {
            type: String,
            default: ''
        },
        /**
         * 输入框的内容
         */
        input: {
            type: String,
            default: ''
        }
    },
    computed: {
        mentionsList () {
            return [
                ...this.MODEL_LIST
            ];
        }
    },
    watch: {
        input (val) {
            this.prompt = val;
        },
        prompt (val) {
            if (val && val[0] === '/') {
                this.$emit('showModel');
            }
            if (val && val.indexOf('/?') > -1) {
                this.$bus.$emit('openAiModel');
                this.prompt = this.prompt.replace('/?', '');
            }
        }
    },
    mounted () {
        this.prompt = this.input;
    },
    methods: {
        handleFocus (focus) {
            this.$emit('focus-typing', focus);
        },
        // ask () {
        //     this.$emit('serverAsk', { input: this.prompt, url: 'ws://172.25.11.81:8080/websocket/getAnswer/' });
        //     this.prompt = '';
        // },
        /**
         * 上传
         */
        async send () {
            if (this.prompt.trim() === '' || !this.fileUrl) {
                this.$message.error('请输入内容和上传图片后再发送');
                return;
            }
            try {
                let url = this.fileUrl;
                // 截取URL，去掉前面的域名
                if (url.indexOf('/llm/') >= 0) {
                    url = '/llm-files/' + url.substring(url.indexOf('/llm/') + 5);
                }
                let input = `${this.prompt}\n![图片](${url})`;
                this.$emit('askAnswer', { input });
                let ret = await yjyAPI.img2text_person_counting(this.fileUrl);

                let title = '人群密度估计';
                let answer = ret || '未识别数据';
                this.$emit('askAnswer', { answer, nospeech: true });
                this.oneUpload = null;
                this.prompt = '';
                this.fileUrl = '';
            } catch (err) {
                console.error(err);
            }
        },
        ask (event) {
            if (event && !event.altKey) {
                this.send();
            }
        },
        wrap (event) {
            if (event.altKey) {
                this.prompt = this.prompt + '\n';
            }
        },
        selectValue (data) {
            this.$emit('setModel', data.value);
            this.prompt = this.prompt.replace(`/${data.value}`, '');
        }
    }
};
</script>

<style scoped lang="scss">
@import './gpt-chatbox-yjy-base.scss';
</style>
